import React from 'react';
import classnames from 'classnames';
import Icon from '@hydra/common/components/Icon';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: 0,
    cursor: 'pointer',
    paddingBottom: 0,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
}));

export default function Order ({ children, onChange = () => {}, order = 0, ...props }) {
  const classes = useStyles();
  const handleChange = () => onChange(order === 1 ? -1 : 1);
  const { ...extraProps } = props;
  let icon = 'triangle-right';
  if (order === 1) {
    icon = 'triangle-up';
  } else if (order === -1) {
    icon = 'triangle-down';
  }

  return (
    <span
      onClick={handleChange}
      {...extraProps}
      className={classnames(classes.root, extraProps.className)}
    >
      {children}
      &nbsp;
      <Icon type={icon} size='md' color='grey' />
    </span>
  );
}
